import * as apiMethods from 'lib/communication';
import createAction from 'lib/createAction';

import {
  LOAD,
  CREATE,
  UPDATE,
  CANCEL,
  EDIT,
  DONE,
  REMOVE,
  SET_VIEW_ID,
  CLEAR_VIEW_ID,
  SET_DELETE_ID,
  CLEAR_DELETE_ID,
  COMMIT_PUT,
} from './actionTypes';

const apiMethodWrapper =
  (method, expectArray = false) =>
  (...args) =>
    new Promise((resolve, reject) =>
      method
        .call(this, ...args)
        .then(res => (res.isSuccess ? resolve(expectArray ? res.data : res.data[0]) : reject(res.err))),
    );

const get = apiMethodWrapper(apiMethods.get, true);
const post = apiMethodWrapper(apiMethods.post, true);
const patch = apiMethodWrapper(apiMethods.patch);
const put = apiMethodWrapper(apiMethods.put, true);

/*
  Action creators.
  - createAction signature: type, meta, payload, promise
  - null/undefined values get ignored
 */

export const load = module => createAction(LOAD, { module }, null, get(`/docs/${module}/get`));

export const create = module => createAction(CREATE, { module }, null, post(`/docs/${module}/create`));

export const update = (module, id, fields) =>
  createAction(UPDATE, { module }, null, patch(`/docs/${module}/update`, { data: { document_id: id, ...fields } }));

export const edit = (module, id) =>
  createAction(EDIT, { module, id }, null, post(`/docs/${module}/edit`, { data: { document_id: id } }));

export const cancel = (module, id) =>
  createAction(CANCEL, { module, id }, null, post(`/docs/${module}/cancel`, { data: { document_id: id } }));

export const done = (module, id) =>
  createAction(DONE, { module, id }, null, post(`/docs/${module}/done`, { data: { document_id: id } }));

export const remove = (module, id) =>
  createAction(REMOVE, { module, id }, null, post(`/docs/${module}/remove`, { data: { document_id: id } }));

export const commitPut = (module, id, fields, tokenId = undefined) =>
  createAction(
    COMMIT_PUT,
    { module, id },
    null,
    put(
      `/docs/${module}/done`,
      { data: { document_id: id, ...fields } },
      {},
      tokenId ? { 'x-study-token-id': tokenId } : undefined,
    ),
  );

// View id actions
export const setViewId = (module, id) => createAction(SET_VIEW_ID, { module }, id);

export const clearViewId = module => createAction(CLEAR_VIEW_ID, { module });

// Delete id actions
export const setDeleteId = (module, id) => createAction(SET_DELETE_ID, { module }, id);

export const clearDeleteId = module => createAction(CLEAR_DELETE_ID, { module });
